export enum VideoTutorialLocation {
  MEAL_PLANNER = 'meal_planner',
  DASHBOARD = 'dashboard',
  CALENDAR = 'calendar',
  TASKS = 'tasks',
  GOALS = 'goals',
  CONTACTS = 'contacts',
  APPS = 'apps',
}

export interface VideoTutorialData {
  title?: string;
  location?: VideoTutorialLocation;
  video_url?: string;
  thumbnail_url?: string;

  vimeo_id?: string;
  youtube_id?: string;
}
